import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Typography } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import productService from "./ProductService";
import InputField from "../../componentes/form-fields/InputField/InputField";
import DefaultChip from "../../componentes/chip/DefaultChip";

export default function ProductGeneric() {
    const { t } = useTranslation();
    const { control } = useForm();

    const userId = sessionStorage.getItem("userId");
    const loggedIdClient = Number(sessionStorage.getItem("idClient") || 0);

    const initialProductState = {
        idProduct: 0,
        idClient: loggedIdClient,
        productName: '',
        ean: '',
        status: 1,
        userId: userId,
    };


    const [product, setProduct] = useState(initialProductState);

    const { productName, ean, idClient, status } = product

    const [clearedProduct, setClearedProduct] = useState(false);
    const [programRoleRows, setProductRows] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const columnsProduct = (t) => [
        {
            field: "idCliente",
            textAlign: 'center',
            visible: false,
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="idCliente" name="" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.idClient}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "idProduct",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="ids" name="id" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.idProduct}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "productName",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="productName" name="productName" />;
            },
        },
        {
            field: "ean",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="ean" name="code" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="grey"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.ean}
                            </Typography>}
                        />
                    </>
                )
            }
        }
    ];


    const handleChange = (event) => {
        const { name, value } = event.target;
        setProduct({ ...product, [name]: value });
    };

    const handleCloseAlertProduct = () => {
        setProduct({ ...product });
        setError(false);
        setSuccess(false);
    };

    const handleClearProduct = () => {
        setClearedProduct(!clearedProduct);
        setProduct(initialProductState);
        setProductRows([]);
        setError(false);
        setSuccess(false);
    };

    const handleSearchProduct = () => {
        let request = {
            ...product
        }

        productService
            .getProductGeneric(request)
            .then((response) => {
                setProductRows(response.data)
            })
            .catch((e) => {
            });
    };

    const canSaveProduct = () => {
        if (!productName || !ean || !idClient) {
            setError(true);
            setMessage(t("fillRequiredFields"));
            return false;
        } else if (status === 0) {
            console.log("status cancelado", status);
            setError(true);
            setMessage(t("errorCannotRegisterCancelledProduct"));
            return false;
        }

        setError(false);
        return true;
    };

    const handleSaveProduct = () => {
        let request = { ...product, userId: userId };

        if (!canSaveProduct()) {
            return;
        }

        setMessage("");
        setSuccess(false);
        setProduct({ ...product, warningProduct: false });
        productService
            .createProductGeneric(request)
            .then((response) => {
                setProduct({ ...product, id: response.data.idProduct });
                setProductRows(response.data)
                setMessage(t("saveSuccess"));
                setSuccess(true);
                handleSearchProduct();
            })
            .catch((e) => {
                setMessage(t("saveError"));
            });
    };

    const handleClickGrid = (rowData) => {
        setMessage("");
        setSuccess(false);

        setProduct({
            idProduct: rowData.idProduct,
            productName: rowData.productName,
            ean: rowData.ean,
            sku: rowData.sku,
            productCode: rowData.productCode,
            anvisaRegNumber: rowData.anvisaRegNumber,
            advertence: rowData.advertence,
            idClient: rowData.idClient,
            productGroup: rowData.productGroup,
            qttyBox: rowData.qttyBox,
            status: rowData.status
        });
    }

    useEffect(() => {
        handleSearchProduct();
    }, [])

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="product"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                error={error}
                                success={success}
                                message={message}
                                handleCloseAlert={handleCloseAlertProduct}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={3} md={3}>
                                    <div style={{
                                        pointerEvents: loggedIdClient !== 0 ? "none" : "auto",
                                        opacity: loggedIdClient !== 0 ? 0.8 : 1
                                    }}>
                                        <DefaultAutocomplete
                                            iconLabelSwitch={
                                                <IconLabelSwitch
                                                    name={loggedIdClient !== 0 ? "unLock" : "user"}
                                                    labelName="client"
                                                />
                                            }
                                            name="idClient"
                                            onChange={loggedIdClient !== 0 ? undefined : handleChange}
                                            disabled={loggedIdClient !== 0}
                                            value={idClient}
                                            defaultSize
                                            useApi
                                            endpoint='GetClientGeneric'
                                            error={error && !idClient}

                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="productName" />
                                        }
                                        name="productName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={productName}
                                        length={50}
                                        error={error && productName === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="code" labelName="ean" />
                                        }
                                        name="ean"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={ean}
                                        length={30}
                                        error={error && ean === ""}
                                    />
                                </Grid>
                            </GridInputRow>
                            <SearchClearSaveRow
                                onClickClear={handleClearProduct}
                                onClickSearch={handleSearchProduct}
                                onClickSave={handleSaveProduct}
                            />

                        </GridItemContainer>
                    </>
                }
            />
            {programRoleRows.length > 0 ? (
                <DefaultScreenAccordion

                    fields={
                        <DefaultDatagrid
                            columns={columnsProduct(t, handleSearchProduct)}
                            dataSource={programRoleRows}
                            cellSelected={(args, grid) => handleClickGrid(args.data)}
                            allowPaging={true}
                        />
                    } />
            ) : null}
        </>
    );
};
